import { location } from 'cdui-js';
import i18n from '../../../../i18n';
import { showActionSheet } from '../../components/ActionSheet';
import frontImg from '../../../../assets/deposit/cheque-front-img.svg';
import backImg from '../../../../assets/deposit/cheque-back-img.svg';
import atmImg from '../../../../assets/deposit/cheque-atm-img.svg';
import counterImg from '../../../../assets/deposit/cheque-counter-img.svg';
import { IconCopy } from './icons';
import { DepositShell } from './Shell';
import { copyText, dash, depositUrl, readDepositQuery } from './shared';
import './deposit.css';

const samples = () => [
  { label: i18n.H5Deposit.ChequeFront, src: frontImg },
  { label: i18n.H5Deposit.ChequeBack, src: backImg },
  { label: i18n.H5Deposit.AtmVoucher, src: atmImg },
  { label: i18n.H5Deposit.CounterVoucher, src: counterImg },
];

export const DepositChequeStep1 = () => {
  const query = readDepositQuery();

  const openAll = () => {
    showActionSheet({
      title: i18n.H5Deposit.SampleTitle,
      content: () => (
        <div class="flex-column gap-12px">
          {samples().map((item) => (
            <div>
              <div class="font-s-S color-D">{item.label}</div>
              <img src={item.src} alt={item.label} style={{ width: '100%', height: '116px', 'object-fit': 'contain' }} />
            </div>
          ))}
        </div>
      ),
    });
  };

  const copies = () => [
    { label: i18n.H5Deposit.LabelAccountName, value: query.payeeBankName },
    { label: i18n.H5Deposit.LabelAccountNo, value: query.payeeBankAccountNum },
    { label: i18n.H5Deposit.LabelBankCode, value: query.payeeBankCode },
  ];

  return (
    <DepositShell
      title={i18n.FundH5.MethodCheque}
      footer={
        <div class="footer">
          <button
            type="button"
            class="btn-primary"
            onclick={() => location.routeTo(depositUrl('/h5/deposits/cheque/step2'))}
          >
            {i18n.H5Deposit.SubmitProofCta}
          </button>
          <div class="contact">{i18n.H5Deposit.ContactCs}</div>
        </div>
      }
    >
      <div class="cheque">
        <div>
          <div class="cheque-title">{i18n.FundH5.MethodCheque}</div>
          <div class="tags">
            <span class="tag">{i18n.H5Deposit.TagZeroFee}</span>
            <span class="tag">{i18n.H5Deposit.TagArrive2Days}</span>
          </div>
        </div>

        <div class="step">
          <div class="step-hd">
            <b>①</b>
            {i18n.H5Deposit.Step1Fill}
          </div>
          <div class="desc">{i18n.H5Deposit.Step1Desc}</div>
          <div class="img-card">
            <img src={frontImg} alt={i18n.H5Deposit.ChequeFront} />
            <div class="img-label">{i18n.H5Deposit.ChequeFront}</div>
          </div>
          <div class="img-card">
            <img src={backImg} alt={i18n.H5Deposit.ChequeBack} />
            <div class="img-label">{i18n.H5Deposit.ChequeBack}</div>
            <div class="desc">{i18n.H5Deposit.Step1BackExample}</div>
          </div>
        </div>

        <div class="step">
          <div class="step-hd">
            <b>②</b>
            {i18n.H5Deposit.Step2Submit}
          </div>
          <div class="desc">{i18n.H5Deposit.Step2Via}</div>
          <div class="detail-card">
            {copies().map((item) => (
              <div class="detail-row">
                <div class="detail-label">{item.label}</div>
                <div class="detail-value">
                  <span>{dash(item.value)}</span>
                  <button type="button" class="copy-btn" onclick={() => copyText(item.value)}>
                    <IconCopy />
                  </button>
                </div>
              </div>
            ))}
          </div>
          <div class="tips">
            <div class="tips-title">{i18n.H5Deposit.KeepVoucherTitle}</div>
            <div class="desc">{i18n.H5Deposit.KeepVoucherDesc}</div>
          </div>
          <div class="img-card">
            <img class="preview-img" src={frontImg} alt={i18n.H5Deposit.ChequeFront} />
            <button type="button" class="view-all" onclick={openAll}>
              {i18n.H5Deposit.ViewAllImages}
            </button>
          </div>
        </div>

        <div class="step">
          <div class="step-hd">
            <b>③</b>
            {i18n.H5Deposit.Step3Notify}
          </div>
        </div>
      </div>
    </DepositShell>
  );
};
